/**
 * 사이드바 렌더러 - reward-app 스타일
 * ui-layout 라이브러리에서 공통으로 사용
 * 리팩토링된 버전: 각 섹션을 독립적인 컴포넌트로 분리
 */ import React, { useState, useEffect } from 'react';
import { isTabletView as checkIsTablet, isIconOnlyMode as checkIsIconOnly, SIDEBAR_WIDTHS } from '@edusense/shared-constants';
import { LogoSection, NavigationSection, AccountSection } from './sidebar';
import { SidebarActionArea } from '../styles/styles/sidebar.styles';
export const SidebarRenderer = (props)=>{
    const { navigationItems = [], activeMenu, onMenuClick, onLogoClick, logoText, logoImage, userName, userAvatar, isAuthenticated = false, onLogout, onLoginClick, isMobileSidebar = false, onClose, userProfileComponent, actionButton, logoTextStyle, accountSectionVersion } = props;
    const [isTabletView, setIsTabletView] = useState(false);
    const [isIconOnlyMode, setIsIconOnlyMode] = useState(false);
    useEffect(()=>{
        const updateViewport = ()=>{
            const width = window.innerWidth;
            setIsTabletView(checkIsTablet(width));
            setIsIconOnlyMode(checkIsIconOnly(width));
        };
        updateViewport();
        window.addEventListener('resize', updateViewport);
        return ()=>window.removeEventListener('resize', updateViewport);
    }, []);
    // 기본 네비게이션 아이템 정의 - 앱별로 다른 기본값은 props로 전달받도록
    const defaultNavItems = [];
    const navItems = navigationItems.length > 0 ? navigationItems : defaultNavItems;
    const effectiveIconOnly = isMobileSidebar ? false : isIconOnlyMode;
    const sidebarWidthValue = isMobileSidebar ? '100%' : effectiveIconOnly ? `${SIDEBAR_WIDTHS.ICON_ONLY}px` : `${SIDEBAR_WIDTHS.STANDARD}px`; // PC 뷰에서도 STANDARD 사용
    const enhancedActionButton = /*#__PURE__*/ React.isValidElement(actionButton) ? /*#__PURE__*/ React.cloneElement(actionButton, {
        ...actionButton.props,
        isIconOnlyMode: actionButton.props?.isIconOnlyMode ?? effectiveIconOnly,
        isTabletView: actionButton.props?.isTabletView ?? isTabletView,
        isMobileSidebar: actionButton.props?.isMobileSidebar ?? isMobileSidebar
    }) : actionButton;
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            padding: 0,
            height: '100%',
            width: sidebarWidthValue,
            maxWidth: isMobileSidebar ? '100%' : sidebarWidthValue,
            display: 'flex',
            flexDirection: 'column',
            alignItems: effectiveIconOnly ? 'center' : 'stretch',
            justifyContent: 'flex-start',
            gap: 0,
            backgroundColor: 'var(--theme-paper, #ffffff)',
            fontFamily: "'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            overflow: 'visible'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            padding: effectiveIconOnly ? '0.5rem' : isTabletView ? '0.75rem 1rem' : '1.25rem 1.5rem'
        }
    }, /*#__PURE__*/ React.createElement(LogoSection, {
        logoText: logoText,
        logoImage: logoImage,
        onLogoClick: onLogoClick,
        isTabletView: isTabletView,
        isMobileSidebar: isMobileSidebar,
        isIconOnlyMode: effectiveIconOnly,
        onClose: onClose,
        logoTextStyle: logoTextStyle
    })), /*#__PURE__*/ React.createElement("div", {
        style: {
            flex: 1,
            width: '100%',
            padding: effectiveIconOnly ? '0.5rem 0.35rem 0.75rem' : isTabletView ? '0.75rem 1rem 1rem' : '1.25rem 1.5rem 1.5rem',
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ React.createElement(NavigationSection, {
        navigationItems: navItems,
        activeMenu: activeMenu,
        onMenuClick: onMenuClick,
        isTabletView: isTabletView,
        isMobileSidebar: isMobileSidebar,
        isIconOnlyMode: effectiveIconOnly
    })), enhancedActionButton && /*#__PURE__*/ React.createElement("div", {
        style: {
            padding: effectiveIconOnly ? '0 0.35rem' : isTabletView ? '0 0.75rem' : '0 1.25rem'
        }
    }, /*#__PURE__*/ React.createElement(SidebarActionArea, {
        isMobileSidebar: isMobileSidebar,
        isTabletView: isTabletView
    }, enhancedActionButton)), /*#__PURE__*/ React.createElement("div", {
        style: {
            marginTop: 'auto',
            width: '100%',
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ React.createElement(AccountSection, {
        isAuthenticated: isAuthenticated,
        userName: userName,
        userAvatar: userAvatar,
        onLogout: onLogout,
        onLoginClick: onLoginClick,
        isTabletView: isTabletView,
        isMobileSidebar: isMobileSidebar,
        isIconOnly: effectiveIconOnly,
        userProfileComponent: userProfileComponent,
        version: accountSectionVersion ?? 'heroui'
    })));
};
export default SidebarRenderer;
